class TrackingUtils {

    constructor() {
        this.isLogEnabled = false;
        this.checkLogEnabled();
    }

    log(message) {
        this.isLogEnabled && console.log(message)
    }

    checkLogEnabled() {
        this.isLogEnabled = (location.href.indexOf('trackinglog=true') > -1) ? true : false;
    }

    /**
     * set tracking for link element
     * @param {*} links
     * @param {*} service
     * @param {*} trackingObj
     *     Example:
     *        TrackingUtils.setLinkTracking(document.querySelectorAll('.more-video > a.fs-more-btn'),'parsely',{
     *            'utm_campaign'  : 'more_videos',
     *            'utm_medium'    : 'fscom',
     *            'utm_content'   : 'morelink'
     *        });
     */
    setLinkTracking(links, service, trackingObj) {
        if (!links || !links.length || !service) return;

        if (links.constructor.name === 'NodeList') {
            links = [...links];
        }

        links.forEach(link => {
            if (link.hasAttribute('data-link-tracked-by')) return;

            if ('parsely' === service) {
                link.addEventListener('click', (e) => { this.ParselyTrackLink(e, trackingObj) });
            }
            link.setAttribute('data-link-tracked-by', service);
        });

    }

    /**
     * add to target's event.addEventListener
     * @param {*} ev
	 * @param trackingObj
     */
    ParselyTrackLink(ev, trackingObj) {
        if (ev.preventDefault) ev.preventDefault();

        let target = ev.currentTarget || ev.target;
        let url = target.getAttribute('href');
        let urlToTrack = target.getAttribute('data-url-to-track');

        if (typeof PARSELY !== "undefined" && typeof PARSELY.beacon === "object" && typeof PARSELY.beacon.trackPageView === 'function') {
            let parselyObj = {
                'url'   : this.addTrackingQuery(trackingObj, urlToTrack || url),
                'js'    : 1
            };

            PARSELY.beacon.trackPageView(parselyObj);
        }

		window.open(url, target.getAttribute('target') || '_self');
    }

    /**
     * constructing url param by using JS object (wrapping function)
     * @param {*} trackingObj
     * @param {*} url
     */
    addTrackingQuery(trackingObj, url) {
        for (var i in trackingObj) {
            let val = trackingObj[i];
            if (val) {
                url = this.updateQueryStringParam(url, i, val);
            }
        }
        return url;
    }

    /**
     * constructing url param by using JS object (actual logic)
     * based on "https://stackoverflow.com/a/6021027"
     * @param {*} uri
     * @param {*} key
     * @param {*} value
     */
    updateQueryStringParam(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
            var hash = '';
            if (uri.indexOf('#') !== -1) {
                hash = uri.replace(/.*#/, '#');
                uri = uri.replace(/#.*/, '');
            }
            var separator = uri.indexOf('?') !== -1 ? "&" : "?";
            return uri + separator + key + "=" + value + hash;
        }
    }

    /**
     * get vide title, image and section from video player info
     * @returns Object {{title: string, image_url: string}}
     */
    getTrackingMeta(player) {

        let title = '';
        let thumbnail = '';
        let section = '';
        let id = '';
        let url = '';

        if (typeof player.videoinfo.thumbnail !== "undefined") {
            thumbnail = player.videoinfo.thumbnail;
        }

        if (typeof player.videoinfo.title !== "undefined") {
            title = player.videoinfo.title;
        }

        if (typeof player.videoinfo.primary !== "undefined") {
            section = player.videoinfo.primary;
        }

        if (typeof player.videoinfo.id !== "undefined") {
            id = player.videoinfo.id;
        }

        if (typeof player.url !== "undefined") {
            url = player.url;
        }


        return {
            title: title,
            image_url: thumbnail,
            section: section,
            id: id,
            url: url
        }
    }

    /**
     * @desc event triggered on player OnMediaStart and OnMediaUnpause events
     * @param isAd True or False for e.data.baseClip.isAd that is passed from player OnMediaStart and OnMediaUnpause events
     * @returns {FsVideo}
     */
    sendPlay(isAd, player, utmObj) {
        //only send parsely tracking on video play when the video clip is not an ad
        if (!isAd) {
            let metadata = this.getTrackingMeta(player);
            this.sendTracking("play", metadata, utmObj);
        }

        return this;
    }

    /**
     * @desc event triggered on player OnMediaStart event
     * @returns {FsVideo}
     */
    sendPause(isAd, player, utmObj) {

        this.isPlaying = false;
        this.isPaused = true;

        //only send parsely tracking on video pause when the video clip is not an ad
        if (!isAd) {
            let metadata = this.getTrackingMeta(player);
            this.sendTracking("pause", metadata, utmObj);
        }

        return this;
    }

    /**
     * @desc Send parsely tracking when video is played or paused
     * parsely doc: https://www.parsely.com/help/integration/video/
     * @param type
     * @param metadata
     * @param utmObj
     */
    sendTracking(type, metadata, utmObj) {

        //if only send parsely tracking when there is video ID and PARSELY is available
        var isParsely = (typeof PARSELY !== 'undefined' && typeof PARSELY.video === 'object');
        if (typeof metadata !== "undefined" && metadata.id !== "undefined" && isParsely) {

            /**
             * we only include title, image_url and section for tracking
             * We don't have pub_date_tmsp, tags and authors from the video player info.
             * We can get them, but it will require additional server call for the videos,
             * so we skip including them at this moment
             */
            let urlOverride = (metadata.url !== '') ? metadata.url : (location.origin + location.pathname);
            //let metadata = this.getTrackingMeta();

            metadata.section = utmObj.utm_content || utmObj.utm_section;
            urlOverride = this.addTrackingQuery(utmObj, urlOverride);

            //the following log info for debugging purpose on the console. We will remove it when we release it to prod
            this.log(`
                    VIDEO TRACKING: sending parsely data
                    type: ${type}
                    title: ${metadata.title}
                    thumbnail: ${metadata.image_url}
                    vid: ${metadata.id}
                    urlOverride: ${urlOverride}
                    config: ${JSON.stringify( metadata )} 
            `)

            try {
                if (type === 'play') {
                    PARSELY.video.trackPlay(metadata.id, metadata, urlOverride);
                } else if (type === 'pause') {
                    PARSELY.video.trackPause(metadata.id, metadata, urlOverride);
                } else {
                    console.log("Tracking Type Not Supported", type);
                }
            } catch (err) {
                console.log("Error sending tracking info: ", err);
            }

        }
    }

    /**
     * @desc replace string to a slug-like format
     * @returns String
     * i.e., "This Is A Slug!" = "this-is-a-slug"
     */
     formatStringAsSlug(str){
        return str.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
     }
}

export default new TrackingUtils();



// WEBPACK FOOTER //
// ./assets/components/fsUtils/TrackingUtils.js